module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }